export enum RelationshipTypeId {
  CriticalCapabilities = 1,
  BranchContextualization = 2,
  UpdateBranch = 3,
  PerspectiveContextualization = 8,
  VariantContextualization = 9,
  Contextualization = 100,
  UNI = 200,
  ReportHighlight = 300,
  ResearchCollections = 9999, //dummy id to differentiate in the front end
  Summary_Translation = 5,
  Summary_Translation_Localization = 10,
  Full_Translation = 11,
  Translation = 400,
  Clone = 9998,
  ConceptItem = 12,
  CompanionProfile = 600,
  ProjectItem = 700,
  MarketDefinition = 8888,
  Association = 1000,
  Series = 1234
}

export enum ConferenceRelationshipTypeId {
  DirectPickup = 2,
  Modification = 3,
  TranslationDirectPickup = 4,
  TranslationModification = 5
}
